import type FormCC from "@/interface/FormCC";
import MasterService from "@/service/restfulService/CCOnboardMasterService";
import { ref, type Ref } from "vue";

export default async function employmentSubmit(
  ccFormValue: Ref<FormCC>,
  prop: any,
  page6Overlay: Ref<boolean>,
  isTimeOut: Ref<boolean>,
  isSessionEnd: Ref<boolean>,
  jumpStep: (value: number, name: string, page: string) => void
): Promise<void> {
  page6Overlay.value = true;
  const postCode = ref("80000");
  const city = ref("");
  const state = ref("");
  if (ccFormValue.value.employmentDetails.question2 == "No") {
    try {
      const res = await MasterService.checkPostCode(postCode.value);

      if (res.status == 200) {
        city.value = res.data.responseModel.city;
        state.value = res.data.responseModel.state;
      }
    } catch (error) {
      page6Overlay.value = false;
    }
  }
  const requestModel = {
    dropOffStep: "S7",
    webFormRequestId: ccFormValue.value.webFormRequestId,
    cardId: prop.cardId,
    icNumber: ccFormValue.value.basicInformation.idNo,
    webFormDetails: {
      employmentDetailInfo: {
        my2ndHome:
          ccFormValue.value.employmentDetails.question1 == "Yes" ? true : false,
        workInMY:
          ccFormValue.value.basicInformation.profession == "20"
            ? ""
            : ccFormValue.value.employmentDetails.question2 == "Yes"
            ? true
            : false,
        occupationType: ccFormValue.value.employmentDetails.occupation,
        employmentType: ccFormValue.value.employmentDetails.employment,
        incomeType: ccFormValue.value.employmentDetails.employmentIncome,
        companyName: ccFormValue.value.employmentDetails.companyName,
        sstRegistrationNo:
          ccFormValue.value.employmentDetails.occupation == "1"
            ? ccFormValue.value.employmentDetails.sstRegistrationNo
            : "",
        companyAddress: {
          addressLine1: ccFormValue.value.employmentDetails.companyAddress1,
          addressLine2: ccFormValue.value.employmentDetails.companyAddress2,
          addressLine3: ccFormValue.value.employmentDetails.companyAddress3,
          postcode:
            ccFormValue.value.basicInformation.profession == "20"
              ? ""
              : ccFormValue.value.employmentDetails.question2 == "Yes"
              ? ccFormValue.value.employmentDetails.postCode
              : postCode.value,
          city:
            ccFormValue.value.employmentDetails.question2 == "Yes"
              ? ccFormValue.value.employmentDetails.city
              : city.value,
          state:
            ccFormValue.value.employmentDetails.question2 == "Yes"
              ? ccFormValue.value.employmentDetails.state
              : state.value,
        },
        companyPhoneNoCountryCode:
          ccFormValue.value.employmentDetails.countryCode,
        companyPhoneNo: ccFormValue.value.employmentDetails.phoneNo,
        areaCode: ccFormValue.value.employmentDetails.areaCode,
        natureOfBusiness: ccFormValue.value.employmentDetails.natureBusiness,
        otherNOB: ccFormValue.value.employmentDetails.others,
        lengthOfEmployment: {
          year:
            ccFormValue.value.employmentDetails.yearEmp == ""
              ? 0
              : ccFormValue.value.employmentDetails.yearEmp,
          month:
            ccFormValue.value.employmentDetails.monthEmp == ""
              ? 0
              : ccFormValue.value.employmentDetails.monthEmp,
        },
      },
    },
  };
  const editEmploymentValidateRequest = {
    webFormRequestId: ccFormValue.value.webFormRequestId,
    cardId: prop.cardId,
    employmentDetailInfo: {
      my2ndHome:
        ccFormValue.value.employmentDetails.question1 == "Yes" ? true : false,
      workInMY:
        ccFormValue.value.basicInformation.profession == "20"
          ? ""
          : ccFormValue.value.employmentDetails.question2 == "Yes"
          ? true
          : false,
      occupationType: ccFormValue.value.employmentDetails.occupation,
      employmentType: ccFormValue.value.employmentDetails.employment,
      incomeType: ccFormValue.value.employmentDetails.employmentIncome,
      companyName: ccFormValue.value.employmentDetails.companyName,
      companyAddress: {
        addressLine1: ccFormValue.value.employmentDetails.companyAddress1,
        addressLine2: ccFormValue.value.employmentDetails.companyAddress2,
        addressLine3: ccFormValue.value.employmentDetails.companyAddress3,
        postcode:
          ccFormValue.value.basicInformation.profession == "20"
            ? ""
            : ccFormValue.value.employmentDetails.question2 == "Yes"
            ? ccFormValue.value.employmentDetails.postCode
            : postCode.value,
        city:
          ccFormValue.value.employmentDetails.question2 == "Yes"
            ? ccFormValue.value.employmentDetails.city
            : city.value,
        state:
          ccFormValue.value.employmentDetails.question2 == "Yes"
            ? ccFormValue.value.employmentDetails.state
            : state.value,
      },
      companyPhoneNoCountryCode:
        ccFormValue.value.employmentDetails.countryCode,
      companyPhoneNo: ccFormValue.value.employmentDetails.phoneNo,
      areaCode: ccFormValue.value.employmentDetails.areaCode,
      natureOfBusiness: ccFormValue.value.employmentDetails.natureBusiness,
      otherNOB: ccFormValue.value.employmentDetails.others,
      lengthOfEmployment: {
        year:
          ccFormValue.value.employmentDetails.yearEmp == ""
            ? 0
            : ccFormValue.value.employmentDetails.yearEmp,
        month:
          ccFormValue.value.employmentDetails.monthEmp == ""
            ? 0
            : ccFormValue.value.employmentDetails.monthEmp,
      },
    },
  };

  if (ccFormValue.value.summarySetting.employmentDetailsJump == true) {
    MasterService.editEmploymentValidate(
      editEmploymentValidateRequest,
      ccFormValue.value.token
    )
      .then((res) => {
        if (res.status == 200) {
          ccFormValue.value.dropOffStep = 7;
          if (res.data.response == "Exist") {
            ccFormValue.value.summarySetting.employmentDetailsJump = false;
            jumpStep(12, "", "6");
            page6Overlay.value = false;
          } else {
            MasterService.pageSubmit(requestModel, ccFormValue.value.token)
              .then((res) => {
                if (res.status == 200) {
                  ccFormValue.value.summarySetting.uploadDocumentsJump = true;
                  ccFormValue.value.summarySetting.principalCardDetailsJump =
                    true;
                  jumpStep(7, "", "6");
                  page6Overlay.value = false;
                } else {
                  page6Overlay.value = false;
                }
              })
              .catch((e) => {
                if (e.response && e.response.data.code == "WB-401") {
                  // EndSession
                  isTimeOut.value = false;
                  isSessionEnd.value = true;
                }
              });
          }
        } else {
          page6Overlay.value = false;
        }
      })
      .catch((e) => {
        if (e.response && e.response.data.code == "WB-401") {
          // EndSession
          isTimeOut.value = false;
          isSessionEnd.value = true;
        }
      });
  } else {
    MasterService.pageSubmit(requestModel, ccFormValue.value.token)
      .then((res) => {
        if (res.status == 200) {
          ccFormValue.value.dropOffStep = 7;
          jumpStep(7, "", "6");
          page6Overlay.value = false;
        } else {
          page6Overlay.value = false;
        }
      })
      .catch((e) => {
        if (e.response && e.response.data.code == "WB-401") {
          // EndSession
          isTimeOut.value = false;
          isSessionEnd.value = true;
        }
      });
  }
}
